import Axios from 'axios'
import _ from 'lodash'
import { IS_WORKER } from '../constants/isWorker'
import { SESSION_HEADER_NAME, SESSION_HEADER_SALT, SESSION_SALT_NAME, SESSION_TOKEN_NAME } from '../constants/session'
import { IS_SERVER } from '../constants/ssr'
import { ftGetLocalStorage } from './common'

let elCache = null

export const primaryDomain = (str) => _.tail(String(str).split('.')).join('.')

export const isFirstTimeLogin = () => {
  try {
    const dynamicData = document.getElementById('__FT__STATIC__')
    if (dynamicData) {
      let data = JSON.parse(dynamicData.textContent || '')
      return data.isFirstTimeLogin
    }
  } catch (error) {}
  return false
}

export const getAccountSettingsPreloader = () => {
  try {
    const dynamicData = document.getElementById('__FT__STATIC__')
    if (dynamicData) {
      let data = JSON.parse(dynamicData.textContent || '')
      return data?.freshState?.preloaderUrl
    }
  } catch (error) {}
  return ''
}

export const getPreviewDynamicData = () => {
  try {
    if (IS_SERVER) {
      return {}
    }
    elCache = elCache || document.getElementById('__FT__STATIC__')
    if (elCache) {
      return JSON.parse(elCache.textContent)
    }
    return {}
  } catch (error) {
    console.log(error)
    return {}
  }
}

export const clearPreviewUserData = () => {
  try {
    if (IS_SERVER) {
      return {}
    }
    elCache = elCache || document.getElementById('__FT__STATIC__')
    if (elCache) {
      let data = JSON.parse(elCache.textContent)
      delete data.user
      delete data.messageValue
      delete data.svParams
      delete data.ssoParams
      elCache.textContent = JSON.stringify(data)
    }
  } catch (error) {
    console.log(error)
  }
}

export const BASE_URL = IS_SERVER || IS_WORKER ? `//${process.env.NEXT_PUBLIC_HOST}/` : `//${window.location.hostname}/`
export const fturl = !IS_SERVER && !IS_WORKER ? window.location.href : ''

let axiosParams = {
  baseURL: BASE_URL,
  headers: {
    fturl,
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
}
if (!IS_SERVER) {
  axiosParams.headers.sfAuthHash = _.get(getPreviewDynamicData(), ['ssoParams', 'sfAuthHash'])
}

export const isDisabledSfIntegration = (action, data) => {
  try {
    let rateTimeLimit = 40
    let rateRequestLimit = 60

    let size = 0
    if (action == 'push') {
      size = _.size(data)
    } else {
      size = _.keys(data).length
    }
    if (window.isDisabledFTRequests) {
      console.error('disabled too many requests')
      return true
    }
    if (!size) {
      return false
    }

    if (!window.listFTRequests) {
      window.listFTRequests = []
    }

    for (var i = 0; i < size; i++) {
      window.listFTRequests.push({
        action: action,
        time: new Date().getTime(),
      })
    }

    let filteredList = []
    let currentTime = new Date().getTime() - rateTimeLimit * 1000
    _.each(window.listFTRequests, function (row) {
      if (row && row.time) {
        if (row.time > currentTime) {
          filteredList.push(row)
        }
      }
    })

    window.listFTRequests = filteredList

    if (window.listFTRequests.length > rateRequestLimit) {
      window.isDisabledFTRequests = true
      console.error('disabled too many requests')
      return true
    }
  } catch (err) {
    console.error(err)
  }
  return false
}

export const getAxios = (req) => {
  if (req) {
    let params = _.merge({}, axiosParams, {
      headers: {
        Cookie: req.headers.cookie,
      },
      withCredentials: true,
    })
    return Axios.create(params)
  } else {
    let axios = Axios.create(axiosParams)
    axios.interceptors.request.use(
      (config) => {
        const token = ftGetLocalStorage(SESSION_TOKEN_NAME)
        if (token) {
          config.headers[SESSION_HEADER_NAME] = token
        }
        const salt = ftGetLocalStorage(SESSION_SALT_NAME)
        if (salt) {
          config.headers[SESSION_HEADER_SALT] = salt
        }
        return config
      },
      (error) => {
        Promise.reject(error)
      }
    )

    return axios
  }
}

export const CancelToken = Axios.CancelToken

// axios.defaults.headers.post['Content-Type'] =
//   'application/x-www-form-urlencoded';
